import React, { useEffect } from "react";
import { ReactComponent as SuccessIcon } from "../../assets/icons/success.svg";
import Navbar from "../navbar";

const Success = ({ user }) => {
  useEffect(() => {
    if (
      document.getElementById("review-success-text") &&
      document.getElementById("review-success-icon")
    ) {
      document.getElementById("review-success-icon").style.width = "15em";
      document.getElementById("review-success-text").style.transform =
        "scale(1)";
    }
  }, [user]);

  if (!user) {
    return <div></div>;
  }

  return (
    <div>
      <Navbar user={user} />
      <div className="flex justify-center items-center h-[70vh] flex-col">
        <SuccessIcon
          className="w-[0em] transition-all duration-500 ease-in-out"
          id="review-success-icon"
        />
        <p
          className="text-[1.5em] md:text-[1.7em] transition-all duration-[900ms] ease-in-out scale-[0] font-medium text-gray-700 mt-10 text-center"
          id="review-success-text"
        >
          Thank you!
          <br /> We've got your feedback!
        </p>
      </div>
    </div>
  );
};

export default Success;
